export const LOCK_DELAY_MS = 650;
export const MAX_LOCK_RESETS = 15;

export class LockDelayController {
  private deadline: number | undefined;
  private resetCount = 0;
  private groundedPreviously = false;
  private hasTouchedGround = false;

  observe(now: number, grounded: boolean): void {
    if (!grounded) {
      this.deadline = undefined;
      this.groundedPreviously = false;
      return;
    }
    if (!this.groundedPreviously) {
      if (!this.hasTouchedGround) {
        this.hasTouchedGround = true;
        this.deadline = now + LOCK_DELAY_MS;
      } else if (this.resetCount < MAX_LOCK_RESETS) {
        this.resetCount += 1;
        this.deadline = now + LOCK_DELAY_MS;
      } else {
        this.deadline = now;
      }
    }
    this.groundedPreviously = true;
  }

  adjusted(now: number, grounded: boolean): void {
    const wasGrounded = this.groundedPreviously;
    this.observe(now, grounded);
    if (!grounded || !wasGrounded || this.deadline === undefined || this.resetCount >= MAX_LOCK_RESETS) return;
    this.deadline = now + LOCK_DELAY_MS;
    this.resetCount += 1;
  }

  shouldLock(now: number, grounded: boolean): boolean {
    this.observe(now, grounded);
    return grounded && this.deadline !== undefined && now >= this.deadline;
  }

  resetPiece(): void {
    this.deadline = undefined;
    this.resetCount = 0;
    this.groundedPreviously = false;
    this.hasTouchedGround = false;
  }
}
